// https://morioh.com/p/8e0b9d2ba0f9
export default function authHeader() {

    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.access_token) {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + user.access_token
        };
    } else {
        return {};
    }
}